import { noyauAccentStyle } from '@/lib/display-tweaks';
import type { NoyauColorToken } from '@mss_creator/shared';
import type { ReactNode } from 'react';

export interface NoyauAccentScopeProps {
  noyau: NoyauColorToken;
  children: ReactNode;
}

/**
 * Settings-page preview only (point 16) — overrides --color-bleu-nuit(-tint/-deep)
 * for its subtree so every existing bg-bleu-nuit/text-bleu-nuit/border-bleu-nuit/
 * ring-bleu-nuit utility picks up `noyau`'s color instead. No component code
 * changes anywhere else; NOT wired to real company.noyau data.
 * `display: contents` keeps this wrapper out of the layout tree entirely.
 *
 * Always renders the same `<div className="contents">` element regardless of
 * `noyau` — only the `style` prop varies (no override for 'bleu-nuit', the
 * real override otherwise). This keeps React's reconciliation identity stable
 * across a toggle of the underlying tweak: switching `noyau` mid-render only
 * updates CSS variables in place, it never unmounts/remounts the subtree
 * (which would otherwise silently wipe unsaved form input, scroll position,
 * etc. in the company-context routes this wraps).
 */
export function NoyauAccentScope({ noyau, children }: NoyauAccentScopeProps) {
  const style = noyauAccentStyle(noyau);
  return (
    <div className="contents" style={style}>
      {children}
    </div>
  );
}
